<template>
  <div class="notice-bar-wrapper">
    <van-notice-bar
      scrollable
      left-icon="volume-o"
      mode="link"
      :text="noticeText"
      :speed="30"
      @close="onClose"
      @click="toMore()"
    >
      <template #right-icon>
        <div class="notice-right-wrap">
          <div class="message-box flex-center" @click.stop="toSiteMessage">
            <SvgIcon iconName="message-1" :width="33" current-color />
            消息
            <span class="message-count" v-if="unreadMessageTotal">{{ unreadMessageTotal }}</span>
          </div>
          <div class="message-box services flex-center" @click.stop="router.push('/services')">
            <SvgIcon iconName="services" :width="33" />
            客服
          </div>
        </div>
      </template>
    </van-notice-bar>
    <van-popup
      class="notice-popup"
      v-model:show="showNotice"
      round
      closeable
      teleport="body"
      :close-on-click-overlay="false"
      @closed="noticePopupClosed"
    >
      <div class="notice-swiper-wrapper" id="home-swiper-ad">
        <div class="header flex-center">
          <span>公告</span>
          <img class="notice-icon" :src="noticeIcon" />
        </div>
        <div class="content">
          <van-swipe class="notice-swiper" :autoplay="3000" indicator-color="var(--theme-primary-color)">
            <van-swipe-item v-for="(item, index) in newsData" :key="index">
              <div class="dialog-content-detail">
                <div class="notice-title" v-if="item.title">{{ item.title }}</div>
                <!-- <div class="notice-date" v-if="item.create_time">
                  {{ item.formatDate }}
                </div> -->
                <div class="notice-content">
                  <a :href="item.content" target="_blank" v-if="item.content_type === 3">{{ item.content }}</a>
                  <router-link to="/task" v-else-if="item.content_type === 2">
                    <Image fit="contain" :src="item.content" style="height: auto" />
                  </router-link>
                  <div v-else class="item-content" v-safe-html="item.content"></div>
                </div>
                <div class="notice-footer">
                  <div class="signature">{{ websiteName }}</div>
                  <div class="flex-center">
                    <van-button
                      type="primary"
                      round
                      v-if="item.is_save_pic"
                      class="action-btn"
                      @click="handleSaveImg(item)"
                    >
                      保存相册
                    </van-button>
                  </div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </van-popup>

    <!-- 跑马灯 -->
    <van-popup
      class="notice-popup"
      v-model:show="showHorseman"
      round
      closeable
      teleport="body"
      :close-on-click-overlay="false"
      @closed="noticePopupClosed"
    >
      <div class="notice-swiper-wrapper">
        <div class="header flex-center">
          <span>跑马灯详情</span>
          <img class="notice-icon" :src="noticeIcon" />
        </div>
        <div class="content">
          <van-swipe class="notice-swiper" :autoplay="3000" indicator-color="#10C8E4">
            <van-swipe-item v-for="(item, index) in HorsemanNewsData" :key="index">
              <div class="dialog-content-detail">
                <div class="notice-title" v-if="item.title">{{ item.title }}</div>
                <div class="notice-date" v-if="item.create_time">
                  {{ item.formatDate }}
                </div>
                <div class="notice-content">
                  <a :href="item.content" target="_blank" v-if="item.content_type === 3">{{ item.content }}</a>
                  <router-link to="/task" v-else-if="item.content_type === 2">
                    <Image fit="contain" :src="item.content" style="height: auto" />
                  </router-link>
                  <div v-else class="item-content" v-safe-html="item.content"></div>
                </div>
                <div class="notice-footer">
                  <div class="signature">{{ websiteName }}</div>
                </div>
              </div>
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref, watch } from 'vue';
import { storeToRefs, useAppStore, useModalStore, useMsgStore, useTenantStore, useUserStore } from '@star/stores';
import { filter, join, map, replace } from 'lodash-es';
import dayjs from 'dayjs';
import Image from '@/components/Image/index.vue';
import { useRouter } from 'vue-router';
import { emitter, EventEnum, saveImg } from '@star/utils';
import { ModalTypeEnum } from '@star/constants';
import { showFailToast } from 'vant';
import html2canvas from 'html2canvas';

const userStore = useUserStore();
const msgStore = useMsgStore();
const modalStore = useModalStore();
const { showNotice, showHorseman } = storeToRefs(modalStore);
// const noticeImageLoadCount=ref(0) // 公告已经加载完成的图片数量
const showNextModal = ref<boolean>(true); // 是否展示下一个modal
const { websiteName } = storeToRefs(useTenantStore());
const router = useRouter();
const { newLists, unreadMessageTotal } = storeToRefs(msgStore);
const { isLogin, userInfo } = storeToRefs(userStore);
const { theme } = storeToRefs(useAppStore());

const noticeIcon = computed(() => {
  return new URL(`/src/assets/img/home/notice_icon_${theme.value}.png`, import.meta.url).href;
});

const noticeText = computed(() => {
  // 过滤，只要类型message_id=13
  let pmdList = filter(newLists.value, (item: any) => item.message_id == 13).map(v => {
    return {
      ...v,
      content:
        '银河官方直营站：欢迎您的到来！卓著信誉与优质服务是永恒的经营理念；本站汇聚顶端【电子 捕鱼 棋牌 真人 体育 彩票 区块链】等各种高品质游戏，丰厚优惠活动期待您的参与。祝您体验愉快、盈利多多! &nbsp;诚挚感谢所有尊贵会员的信任与支持! &nbsp;-- &nbsp;22.TOP银河致上！!',
    };
  });
  return join(
    map(pmdList, (item: any) =>
      item.content
        ? item.content.replace(
            /<(\/?)(p|span|div|br|strong|em|b|i|u|s|ul|li|ol|h1|h2|h3|h4|h5|h6|a|img|table|tr|td|th|tbody|thead|tfoot|style|script)[^>]*>/gi,
            ''
          )
        : item.content
    ),
    ', '
  ).replaceAll(/&nbsp;/g, '\u00A0');
});

// 只有跑马灯的类型
const HorsemanNewsData = computed(() => {
  return map(
    filter(newLists.value, (item: any) => item.ma_id !== 8 && item.is_pop_up > 0 && item.message_id == 13),
    item => {
      return {
        ...item,
        content: item.content ? replace(replace(item.content, /<p>/g, '<div>'), /<\/p>/g, '</div>') : item.content,
        formatDate: dayjs(item.create_time).format('YYYY-MM-DD HH:mm'),
      };
    }
  ) as any[];
});

const newsData = computed(() => {
  console.log(
    'xxxxx----ads',
    map(
      filter(newLists.value, (item: any) => item.ma_id !== 8 && item.is_pop_up > 0 && item.message_id == 10),
      item => {
        return {
          ...item,
          content: item.content ? replace(replace(item.content, /<p>/g, '<div>'), /<\/p>/g, '</div>') : item.content,
          formatDate: dayjs(item.create_time).format('YYYY-MM-DD HH:mm'),
        };
      }
    )
  );
  return map(
    filter(newLists.value, (item: any) => item.ma_id !== 8 && item.is_pop_up > 0 && item.message_id == 10),
    item => {
      return {
        ...item,
        content: item.content ? replace(replace(item.content, /<p>/g, '<div>'), /<\/p>/g, '</div>') : item.content,
        formatDate: dayjs(item.create_time).format('YYYY-MM-DD HH:mm'),
      };
    }
  ) as any[];
});

const onClose = () => {
  console.log('onClose --------------');
};

const noticePopupClosed = async () => {
  await modalStore.hideModal(ModalTypeEnum.NOTICE_MODAL);
};

const toMore = () => {
  // modalStore.showModal(ModalTypeEnum.NOTICE_MODAL);
  modalStore.showModal(ModalTypeEnum.HORSEMAN_MODAL); // 跑马灯
};

const toSiteMessage = () => {
  if (isLogin.value) {
    router.push('/siteMessage');
  } else {
    emitter.emit(EventEnum.LOGIN, { type: 1 });
  }
};

const getUnreadMessage = async () => {
  await msgStore.reqMessageUnread();
};

// 根据日期判断是否弹窗
const isPopUpAnnouncementByDate = () => {
  let isPopUp = false;

  if (!localStorage.getItem('popDate')) {
    isPopUp = true;
  } else {
    if (dayjs().format('YYYY-MM-DD') !== localStorage.getItem('popDate')) {
      localStorage.removeItem('popDate');
      localStorage.removeItem('popUsers');
      isPopUp = true;
    }
  }

  return isPopUp;
};

// 根据用户id判断是否弹窗
const isPopUpAnnouncementByUserID = () => {
  let isPopUp = false;

  if (isLogin.value) {
    const users = localStorage.getItem('popUsers');

    if (users) {
      if (!users?.includes(userInfo.value.cust_id)) {
        isPopUp = true;
      }
    } else {
      isPopUp = true;
    }
  }

  return isPopUp;
};

/**
 * 是否弹出公告
 * @description 每天弹出一次，通过本地存储日期和登录后用户id判断，弹出公告
 */
const isPopUpAnnouncement = () => {
  if (!newsData.value?.length) return;
  // 需求改成每次都弹了
  modalStore.addPopupModal(ModalTypeEnum.NOTICE_MODAL);
};

// 保存图片到手机相册
const handleSaveImg = item => {
  if (item.pic_addr) {
    html2canvas(document.getElementById('home-swiper-ad')!, { useCORS: true }).then(canvas => {
      saveImg(canvas, item.title || item.subject, {
        success: (text: string) => {
          // showSuccessToast(text);
        },
        error: (text: string) => {
          showFailToast(text);
        },
      });
    });
  }
};

watch(
  () => newsData.value,
  (n, o) => {
    if (n.length && !o.length) {
      isPopUpAnnouncement();
    }
  }
);

onMounted(async () => {});

// onActivated(() => {
//   if (isLogin.value) {
//     getUnreadMessage();
//   }
// });
</script>

<style lang="less" scoped>
.notice-right-wrap {
  display: flex;
  align-items: center;
}

.message-box {
  position: relative;
  margin-left: 18px;
  height: 50px;
  border-radius: 9px;
  font-weight: 380;
  font-size: 30px;
  color: #fff;
  padding: 0 18px;
  background: var(--theme-home-message-btn-background);

  &.services {
    background: var(--theme-home-services-btn-background);
  }

  .svg-icon {
    color: #fff;
    margin-right: 9px;
  }

  .message-count {
    width: 96px;
    height: 96px;
    transform: scale(0.6);
    background: url('@/assets/img/mine/message-count.png') no-repeat center;
    background-size: contain;
    color: #fff;
    display: block;
    text-align: center;
    line-height: 90px;
    font-size: 45px;
    position: absolute;
    top: -54px;
    right: -40px;
    padding-top: 6px;
  }

  .icon3 {
    color: rgb(199 199 199) !important;
    margin-top: 6px;
  }
}

.notice-bar-wrapper {
  //height: 54px;
  //display: flex;
  //align-items: center;
  //justify-content: space-between;
  //margin: 28px 36px;

  :deep(.van-notice-bar) {
    background-color: var(--theme-backgroud-color);
    color: #000;
    padding: 0 20px 0 33px;
    flex: 1;
    height: 100px;

    .van-icon {
      color: var(--theme-primary-color);
    }

    .van-notice-bar__content {
      font-size: 36px;
      font-weight: 400;
    }
  }

  .notice-icon {
    width: 40px;
    display: flex;
    align-items: center;
  }

  .content-wrapper {
    overflow: hidden;
    position: relative;
    width: calc(100% - 130px);
    height: 100%;

    .text-scroll {
      position: absolute;
      top: 0;
      left: 0;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      word-break: break-all;
      height: 100%;
      line-height: 54px;
      font-size: 36px;
      font-weight: 400;
      color: #000;
    }
  }

  .more {
    width: 45px;
    height: 45px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--theme-btn-default-background);
    border-radius: 50px;
    border-color: var(--theme-btn-default-border);
    margin-left: 36px;

    :deep(.van-button__icon) {
      color: var(--theme-icon-default-color);
      font-size: 30px;
    }
  }
}

.notice-popup {
  border-radius: 60px;
  overflow: visible;

  :deep(.van-popup__close-icon) {
    color: #fff;
    font-size: 60px;
  }
}

.notice-swiper-wrapper {
  width: 949px;
  min-height: 1283px;
  border-radius: 60px;
  //background-image: url('@assets/img/home/notice_box_bg.png');
  //background-repeat: no-repeat;
  //background-size: contain;
  //background-position: top center;
  background: var(--theme-popup-notice-background);
  display: flex;
  flex-direction: column;

  .header {
    font-weight: 600;
    color: #fff;
    font-size: 68px;
    height: 150px;
    line-height: 120px;
    text-align: center;
    position: relative;
    flex: none;

    .notice-icon {
      position: absolute;
      left: 30px;
      top: -68px;
      width: 186px;
    }
  }

  .content {
    flex: 1;
    background: #fff;
    border-radius: 60px;

    .notice-swiper {
      width: 100%;
      height: 100%;
    }

    :deep(.van-swipe__indicator) {
      background-color: #c5c5c5;
    }

    .dialog-content-detail {
      padding: 60px;
      font-size: 45px;
      color: #3b3b3b;
      font-weight: 400;

      .notice-title {
        line-height: 1.5;
        font-size: 58px;
        font-weight: 500;
        text-align: left;
        margin-bottom: 18px;
        color: #000;
      }

      .notice-date {
        font-size: 38px;
        font-weight: 400;
        line-height: 1.2;
        color: #939393;
        margin-bottom: 30px;
      }

      .notice-content {
        height: 800px;
        overflow-y: auto;
      }

      .notice-footer {
        margin: 45px 0;

        .signature {
          text-align: right;
          font-size: 46px;
          font-weight: 400;
          line-height: 1.3;
        }

        .action-btn {
          height: 105px;
        }
      }

      .item-content {
        position: relative;
        word-wrap: break-word;
        word-break: break-all;
        text-align: justify;

        &::after {
          position: absolute;
          content: '';
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
      }

      .blue-btn-sm {
        box-shadow: none;
      }
    }
  }
}
</style>
